import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router';
import { UserService } from '../user/user.service'
import { Observable } from 'rxjs';
import { User, Role,Organization,Module } from './user.model';
import 'rxjs/add/operator/map';




@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  userList;
  itemCount = 0;
  statusCode: number;
  serverError: string;
  userId = null;
  action = 'Add user';
  roles = [ new Role(1, 'Server Admin' ),new Role(2, 'Site Administrator' ),new Role(3, 'Viewer' ), new Role(3, 'Interactor')];
  organizations = [ new Organization(1, 'DunkinDonuts' ),new Organization(2, 'LFD' )];
  _modules = [ new Module(1, 'Admin Panel' ),new Module(2, 'Sales Dashboard' )];
  selectedIndex;

  regForm = new FormGroup({
    email : new FormControl('', [Validators.required] ),
    password: new FormControl('', [Validators.required,Validators.minLength(6)]),
    display_name : new FormControl('', [Validators.required,Validators.minLength(3)]),
    first_name: new FormControl('', [Validators.required,Validators.minLength(3)]),
    last_name: new FormControl('', [Validators.required,Validators.minLength(3)]),
    role: new FormControl('', [Validators.required]),
    organization: new FormControl('' , [Validators.required]),
    modules: new FormControl('' , [Validators.required]),
  });
  constructor(private router: Router, private service: UserService) {
  }
  ngOnInit(): void {
    if(!!localStorage.getItem('User') == true)
    { this.getUserList();}
    else
    {    this.router.navigate(['/login']);}
   
  }

  getUserList() {
    this.service.getUser().subscribe(result =>
      { 
        this.userList = result,errorCode => this.statusCode = errorCode
      });
  }

  onFormSubmit() {
    let newuser = this.regForm.value;
    this.serverError = null;
    if (this.userId === null) {
      this.service.createUser(newuser).subscribe(successCode => {
        this.statusCode = successCode;
        this.getUserList();
        this.reset();
      }, errorCode => {
        this.statusCode = errorCode;
        if (this.statusCode === 400) this.serverError = 'User with this email already exist';
      });
    } else {
      newuser.id = this.userId;
      this.service.updateUser(newuser.id, newuser)
        .subscribe(successCode => {
          this.statusCode = successCode;
          this.getUserList();
          this.reset();
        },
        errorCode => this.statusCode = errorCode);
    }
  }

  editUser(id, user) {
    this.action = 'Update user';
    this.userId = id;
    this.regForm.setValue({
      email: user.email,
      password: '******************************************************',
      display_name: user.display_name,
      first_name: user.first_name,
      last_name: user.last_name,
      role: user.role,
      organization: user.organization,
      modules: user.modules
    });
    this.password.disable();
  }

  deleteUser(userId) {
    this.service.deleteUser(userId).subscribe(successCode => {
      this.statusCode = successCode;this.getUserList();this.reset();
    },errorCode => this.statusCode = errorCode);
  }



  reset() {
    this.userId = null;
    this.password.enable();
    this.action = 'Add user';
    this.regForm.reset();
    this.role.setValue("");
    this.organization.setValue("");
    this.modules.setValue("");
  }
  



  get email() { return this.regForm.get('email'); }
  get password() { return this.regForm.get('password'); }
  get display_name() { return this.regForm.get('display_name'); }
  get first_name() { return this.regForm.get('first_name'); }
  get last_name() { return this.regForm.get('last_name'); }
  get role() { return this.regForm.get('role'); }
  get organization() { return this.regForm.get('organization'); }
  get modules() { return this.regForm.get('modules'); }

}


// WEBPACK FOOTER //
// ./src/app/home-page/user/user.component.ts